/* clone-pdp.js — Venora PDP runtime (replaces the captured Alpine/PLN scripts).
   Data comes from window.__sbPdp (set inline by sections/product.liquid):
   { formId, variants:[{id,price,compare_at_price,available}], unit, unitCompare, moneyFormat,
     tiers:[{qty,total,compare,label}], atcText }
   Responsibilities: quantity-bundle radios -> form quantity + price block + ATC text;
   price block render; product tabs; FAQ accordion; keeps Dawn's product-form (fetch add -> cart drawer). */
(function () {
  'use strict';
  var D = window.__sbPdp || {};

  // ---------- money ----------
  function fmtNum(n, prec, thou, dec) { prec = prec == null ? 2 : prec; thou = thou == null ? ',' : thou; dec = dec == null ? '.' : dec; n = (n / 100).toFixed(prec); var p = n.split('.'); var d = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou); return d + (p[1] ? dec + p[1] : ''); }
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var f = D.moneyFormat || (window.Shopify && Shopify.money_format) || '{{amount_no_decimals_with_space_separator}} Ft';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/); var v;
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmtNum(cents, 2); break;
      case 'amount_no_decimals': v = fmtNum(cents, 0); break;
      case 'amount_with_comma_separator': v = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtNum(cents, 0, '.'); break;
      case 'amount_with_space_separator': v = fmtNum(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmtNum(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': v = fmtNum(cents, 2, "'"); break;
      case 'amount_with_period_and_space_separator': v = fmtNum(cents, 2, ' ', '.'); break;
      default: v = fmtNum(cents, 2);
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.Elixir_FormatMoney = window.Elixir_FormatMoney || function (c) { return money(c); };

  // ---------- form helpers ----------
  function form() { return (D.formId && document.getElementById(D.formId)) || document.querySelector('.shop-add-to-cart-wrapper form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'); }
  function qtyInput() {
    var f = form(); if (!f) return null;
    var q = f.querySelector('input[name="quantity"]');
    if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = '1'; f.appendChild(q); }
    return q;
  }
  function currentVariant() {
    var f = form(); var id = f && f.querySelector('input[name="id"]') ? f.querySelector('input[name="id"]').value : null;
    var vs = D.variants || [];
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id)) return vs[i];
    return vs[0] || { price: D.unit || 0, compare_at_price: D.unitCompare || 0 };
  }
  function selectedTier() {
    var r = document.querySelector('.quantity-bundle-radio:checked');
    if (!r) return null;
    return { qty: parseInt(r.value, 10) || 1, total: parseInt(r.dataset.price, 10) || 0, compare: parseInt(r.dataset.compare, 10) || 0 };
  }

  // ---------- price block ----------
  function renderPrice() {
    var v = currentVariant(); var t = selectedTier(); var qty = t ? t.qty : (parseInt((qtyInput() || {}).value, 10) || 1);
    var price = t && t.total ? t.total : (v.price || 0) * qty;
    var compare = t && t.compare ? t.compare : ((v.compare_at_price || 0) * qty);
    if (compare <= price) compare = 0;
    /* main price block near the gallery always shows the UNIT price (1x), never the tier total */
    var unitPrice = v.price || D.unit || 0;
    var unitCompareRaw = v.compare_at_price || D.unitCompare || 0;
    var unitCompare = unitCompareRaw > unitPrice ? unitCompareRaw : 0;
    document.querySelectorAll('.shop-product-price-container').forEach(function (c) {
      var p = c.querySelector('.shop-product-price-block'); var cp = c.querySelector('.shop-compare-price'); var sb = c.querySelector('.shop-save-price'); var pct = c.querySelector('[data-save-percentage]');
      if (p) { p.textContent = money(unitPrice); p.classList.toggle('on-sale', unitCompare > 0); }
      if (cp) { cp.textContent = unitCompare ? money(unitCompare) : ''; cp.style.display = unitCompare ? '' : 'none'; }
      if (sb) { sb.style.display = unitCompare ? '' : 'none'; if (pct && unitCompare) pct.textContent = Math.round((unitCompare - unitPrice) / unitCompare * 100); }
    });
    document.querySelectorAll('[data-sticky-price]').forEach(function (el) { el.textContent = money(price); });
    document.dispatchEvent(new CustomEvent('pdp:price', { detail: { price: price, compare: compare, qty: qty } }));
  }

  // ---------- quantity bundle ----------
  function initBundle() {
    var root = document.querySelector('.quantity-bundle-selector'); if (!root) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.quantity-bundle-card'));
    function select(card) {
      cards.forEach(function (c) { c.setAttribute('data-selected', 'false'); var r = c.querySelector('.quantity-bundle-radio'); if (r) r.checked = false; });
      card.setAttribute('data-selected', 'true'); var radio = card.querySelector('.quantity-bundle-radio'); if (radio) radio.checked = true;
      var q = qtyInput(); var n = parseInt(card.dataset.quantity, 10) || 1;
      if (q) { q.value = n; q.dispatchEvent(new Event('change', { bubbles: true })); }
      document.querySelectorAll('input[name="quantity"][data-pdp-mirror]').forEach(function (m) { m.value = n; });
      document.dispatchEvent(new CustomEvent('quantity:changed', { detail: { quantity: n } }));
      renderPrice();
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) { if (e.target.tagName !== 'INPUT') e.preventDefault(); select(card); });
      card.setAttribute('role', 'radio'); card.setAttribute('tabindex', '0');
      card.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(card); } });
    });
    var pre = cards.filter(function (c) { return c.getAttribute('data-selected') === 'true' || (c.querySelector('.quantity-bundle-radio') || {}).checked; })[0] || cards[0];
    if (pre) select(pre);
  }

  // ---------- tabs ----------
  function initTabs() {
    document.querySelectorAll('[class*="product-tabs-container"]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('.product-tab-btn'); var panels = wrap.querySelectorAll('.product-tab-panel');
      btns.forEach(function (b) { b.addEventListener('click', function () { var t = b.getAttribute('data-tab'); btns.forEach(function (x) { x.classList.remove('active'); }); panels.forEach(function (p) { p.classList.remove('active'); }); b.classList.add('active'); var tp = t && document.getElementById(t); if (tp) tp.classList.add('active'); }); });
    });
  }

  // ---------- FAQ accordion ----------
  function initFaq() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-question'), a = item.querySelector('.faq-answer'); if (!q || !a || item.dataset.pdpFaq) return; item.dataset.pdpFaq = '1';
      q.addEventListener('click', function () {
        var open = item.classList.contains('active');
        item.parentElement && item.parentElement.querySelectorAll('.faq-item.active').forEach(function (o) { if (o !== item) { o.classList.remove('active'); var oa = o.querySelector('.faq-answer'); if (oa) oa.style.maxHeight = null; o.querySelector('.faq-question') && o.querySelector('.faq-question').setAttribute('aria-expanded', 'false'); } });
        if (!open) { item.classList.add('active'); q.setAttribute('aria-expanded', 'true'); var inner = a.querySelector('.faq-answer-inner'); a.style.maxHeight = ((inner ? inner.scrollHeight : a.scrollHeight) + 24) + 'px'; }
        else { item.classList.remove('active'); q.setAttribute('aria-expanded', 'false'); a.style.maxHeight = null; }
      });
    });
  }

  // ---------- ATC button text ----------
  function initAtcText() {
    var btn = document.querySelector('.shop-add-to-cart-wrapper .shop-add-to-cart-button .button-text'); if (!btn) return;
    var base = (D.atcText || btn.textContent || '').trim(); if (!base) return;
    document.addEventListener('pdp:price', function (e) { if (D.showPriceInButton) btn.innerHTML = base + ' · ' + money(e.detail.price); else btn.textContent = base; });
  }

  function boot() {
    qtyInput(); initTabs(); initFaq(); initAtcText(); initBundle(); renderPrice();
    var f = form(); if (f) f.addEventListener('change', function (e) { if (e.target && (e.target.name === 'id' || e.target.name === 'quantity')) renderPrice(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ---- delivery ETA: 2–4 business days, Hungarian short months ---- */
(function venoraEta(){
  function addBiz(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)n--;}return x;}
  var M=['jan.','febr.','márc.','ápr.','máj.','jún.','júl.','aug.','szept.','okt.','nov.','dec.'];
  function fmt(d){return M[d.getMonth()]+' '+d.getDate()+'.';}
  function run(){var dd=document.getElementById('dynamic-date');var fx=dd&&dd.getAttribute('data-eta-fixed');
    if(fx&&fx.trim()){var f=fx.trim();var apply=function(){document.querySelectorAll('#dynamic-date, .sticky-add-to-cart__shipping .delivery-date, #stickyAddToCart .delivery-date').forEach(function(el){el.textContent=f;});};
      apply();setTimeout(apply,400);setTimeout(apply,1200);setTimeout(apply,2500);return;}
    var now=new Date();var a=addBiz(now,2),b=addBiz(now,4);var txt=(a.getMonth()===b.getMonth()?M[a.getMonth()]+' '+a.getDate()+'–'+b.getDate()+'.':fmt(a)+' – '+fmt(b));
    document.querySelectorAll('#dynamic-date, .sticky-add-to-cart__shipping .delivery-date').forEach(function(el){el.textContent=txt;});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();


/* ---- ADDITIVE 2026-08-30: buybox gallery videos = silent, no native controls, click toggles play ---- */
(function(){
  function fix(){document.querySelectorAll('video.shop-video').forEach(function(v){
    if(v.dataset.vfix)return; v.dataset.vfix='1';
    v.removeAttribute('controls'); v.controls=false;
    v.muted=true; v.loop=true; v.setAttribute('playsinline','');
    v.addEventListener('click',function(){ v.paused ? v.play().catch(function(){}) : v.pause(); });
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();
  document.addEventListener('shopify:section:load',fix);
  new MutationObserver(fix).observe(document.documentElement,{childList:true,subtree:true});
})();
